import { Link } from 'react-router-dom';
import type { CategoryId } from '@/types/news';
import { getCategoryName } from '@/utils/news';

const colorMap: Record<CategoryId, string> = {
  society: 'bg-primary-100 text-primary-800 border-primary-200',
  entertainment: 'bg-secondary-100 text-secondary-800 border-secondary-200',
  life: 'bg-accent-100 text-accent-900 border-accent-300',
};

interface CategoryTagProps {
  categoryId: CategoryId;
  asLink?: boolean;
}

export default function CategoryTag({ categoryId, asLink = true }: CategoryTagProps) {
  const className = `inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium ${colorMap[categoryId]}`;
  const label = getCategoryName(categoryId);

  if (!asLink) {
    return <span className={className}>{label}</span>;
  }

  return (
    <Link to={`/category/${categoryId}`} className={`${className} pointer-events-auto hover:opacity-80 transition-opacity`}>
      {label}
    </Link>
  );
}